import DOMPurify from 'dompurify';
/**
 * Sanitize HTML before using in Vue templates (v-html)
 * - Removes <script>, on* handlers, and other unsafe content
 * - Only allows safe tags and attributes
 * - Safe for use with v-html in Vue 2
 */
export function safeHtml(html) {
  // 最寬鬆的安全設定，不限制 tags/attrs，只使用 DOMPurify 的基礎防護
  return DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    RETURN_TRUSTED_TYPE: false
  });
}


// WEBPACK FOOTER //
// ./src/helpers/vue-safehtml.js